import React from 'react';

export function T({variable, ignore, noTranslate, isolate, element = 'span', children, ...props}) {
  if (variable) {
    return <var {...{'data-var': variable}}>{children}</var>;
  }

  if (ignore) {
    return React.createElement(element, {'data-ignore': 'true', ...props}, children);
  }

  if (noTranslate) {
    return React.createElement(element, {'data-notranslate': 'true', ...props}, children); 
  }

  if (isolate) {
    return React.createElement(element, {'data-isolate': 'true', ...props}, children);
  }
}